export const apiConfig = {
  basePath: window.basePath || import.meta.env.VUE_APP_API_URL,
};

/**
 * Key for e2e tests (https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do)
 */
export const TEST_RECAPTCHA_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const CYPRESS_RECAPTCHA_BYPASS_TOKEN = 'cypress-e2e-recaptcha-bypass';
